import { Box, Divider, styled } from "@mui/material";

import MedlyLogo from "@/assets/images/medly-logo.svg";
import VitallLogo from "@/assets/images/vitall-logo.svg";

const LogoContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: 12,
});

const LogoDivider = styled(Divider)(({ theme }) => ({
  backgroundColor: theme.palette.primary.light,
  opacity: 0.3,
  height: 28,
  alignSelf: "center",
}));

export const AppIcon = () => {
  return <img src={VitallLogo} alt="Vitall Icon" />;
};

export const AppLogo = () => {
  return (
    <LogoContainer>
      <img src={VitallLogo} alt="Vitall Logo" style={{ height: "26px", width: "auto" }} />
      <LogoDivider orientation="vertical" flexItem />
      <img src={MedlyLogo} alt="Medly Logo" style={{ height: "32px", width: "auto" }} />
    </LogoContainer>
  );
};

export const AppLogoNoText = () => {
  return <img src={VitallLogo} alt="Vitall Logo" width={128} height={128} />;
};
